<template>
  <div class="p-grid crud-demo">
    <div class="p-col-12">
      <div class="card">
        <Toast/>
        
        <DataTable ref="dt" :value="rows" dataKey="id" :paginator="true"
                   :rows="10" :filters="filters"
                   paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                   :rowsPerPageOptions="[5,10,25]"
                   currentPageReportTemplate="Showing {first} to {last} of {totalRecords} result">
          <template #header>
            <div class="table-header">
              <h5 class="p-m-0">{{name}}</h5>
              <span class="p-input-icon-left">
                <i class="pi pi-search"/>
                <InputText v-model="filters['global']" placeholder="Search..."/>
              </span>
            </div>
          </template>

          <Column v-for="item in textHeaders" :key="item.value" :field="item.value" :header="item.display" sortable></Column>
          <Column v-if="name == 'Customers'">
            <template #body="slotProps">
              <a :href="getInvoiceLink(slotProps.data.id)">Invoice</a>
            </template>
          </Column>

        </DataTable>

      </div>
    </div>
  </div>

</template>

<script>
  export default {
    name: "ReportTable",
    props: {
      rows: {
        default: []
      },
      headers: {
        default: []
      },
      name: {
        default: "Report"
      }
    },
    data() {
      return {
        filters: {},
        submitted: false,
        responsiveOptions: [
          {
            breakpoint: '1024px',
            numVisible: 5
          },
          {
            breakpoint: '768px',
            numVisible: 3
          },
          {
            breakpoint: '560px',
            numVisible: 1
          }
        ],
        user_accesses: this.$store.state.accesses,
        userService: null,
        reportService: null,
      }
    },
    created() {},
    mounted() {},
    methods: {
      exportCSV() {
        this.$refs.dt.exportCSV();
      },
      getInvoiceLink(id) {
        return process.env.VUE_APP_BASE_URL + "/invoice/api/v1/" + id;
      }
    },
    computed: {
     textHeaders: function() {
       return this.headers.filter(header => header.display != "Id")
     }
    }
  }
</script>

<style scoped lang="scss">
  .table-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .product-image {
    width: 100px;
    border-radius: 2em;

    &:hover {
      cursor: pointer;
    }

    /*box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);*/
  }

  .p-dialog .product-image {
    width: 150px;
    margin: 0 auto 2rem auto;
    display: block;
  }

  .confirmation-content {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .product-badge {
    border-radius: 2px;
    padding: .25em .5rem;
    text-transform: uppercase;
    font-weight: 700;
    font-size: 12px;
    letter-spacing: .3px;

    &.status-active {
      background: #C8E6C9;
      color: #256029;
    }

    &.status-inactive {
      background: #FFCDD2;
      color: #C63737;
    }
  }
  .p-grid .p-col-12 .card {
    padding: unset;
  }
</style>
